//import React, { useEffect, useRef } from "react";
import { ContactInfo } from "./ContactInfo";
//import { Field } from "formik";
//import { classes } from "../../utils/Classes";

const BillingAddress = (props) => {
  const { values } = props;
  // const { maxHeightTrans } = classes;
  //const isBilligSelected = values.billing_address_selector === "billingAddress";
  // const isShipDelivery = values.delivery === "ship";
  //const differentBillingRef = useRef(null);
  // useEffect(() => {
  //   if (differentBillingRef.current) {
  //     differentBillingRef.current.style.overflow = "hidden";
  //     if (isBilligSelected) {
  //       var timeoutId = setTimeout(() => {
  //         differentBillingRef.current.style.overflow = "visible";
  //       }, 300);
  //     }
  //     return () => {
  //       if (isBilligSelected) {
  //         clearTimeout(timeoutId);
  //       }
  //     };
  //   }
  // }, [isBilligSelected]);
  return (
    <>
      <div className="mt-10">
        <div className="block font-medium text-black mb-3">
          <span>Shipping address</span>
        </div>
        <ContactInfo {...{ values }} />
      </div>
    </>
  );
};

export default BillingAddress;
